export default __webpack_public_path__ + "static/media/surgeon-icon.9627f0cb.svg";